<template>
  <div class="home">
    <!-- Hero Banner -->
    <div class="hero-banner">
      <!-- 添加胶片效果覆盖层 -->
      <div class="film-overlay"></div>

      <!-- 添加扫描线效果 -->
      <div class="scan-line"></div>

      <!-- 添加灰尘和划痕效果 -->
      <div class="dust-overlay"></div>

      <!-- 主要内容 -->
      <v-parallax
        src="https://images.unsplash.com/photo-1461360370896-922624d12aa1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1474&q=80"
        height="400"
        class="hero-parallax"
      >
        <div class="d-flex flex-column fill-height justify-center align-center text-white">
          <div class="text-overlay pa-5 text-center">
            <!-- 添加打字机效果的标题 -->
            <h1 class="text-h2 font-weight-bold mb-4 hero-title typewriter">{{ $t('home.hero.title') }}</h1>

            <!-- 添加淡入效果的副标题 -->
            <div class="text-h6 font-weight-regular hero-subtitle fade-in">
              {{ $t('home.hero.subtitle') }}
            </div>

            <!-- 添加闪烁的分类标签 -->
            <div class="classification-tag mt-4">
              <span class="blink">{{ $t('home.hero.classification') }}</span>
            </div>
          </div>
        </div>
      </v-parallax>
    </div>

    <!-- Mission Statement -->
    <div class="document-paper my-8 mx-auto" style="max-width: 800px;">
      <div class="document-title">{{ $t('home.mission.title') }}</div>
      <div class="document-content">
        <p v-html="$t('home.mission.content').replace(/\n\n/g, '</p><p>')"></p>
        <div class="text-right mt-4">
          <div class="official-seal">
            <div class="seal-text">清算中共</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Document Categories -->
    <h2 class="text-h4 font-weight-bold text-center mb-6">{{ $t('home.categories.title') }}</h2>
    <v-row>
      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            v-bind="props"
            :elevation="isHovering ? 12 : 2"
            :class="{ 'on-hover': isHovering }"
            height="100%"
            class="category-card"
          >
            <v-img
              src="https://images.unsplash.com/photo-1621944190310-e3cca1564bd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80"
              height="200"
              cover
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            >
              <v-card-title class="text-white">{{ $t('home.categories.confidential.title') }}</v-card-title>
            </v-img>
            <v-card-text>
              <p>{{ $t('home.categories.confidential.description') }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                variant="tonal"
                @click="$router.push('/confidential')"
                class="mx-auto mb-2"
              >
                {{ $t('home.categories.confidential.button') }}
                <v-icon end>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            v-bind="props"
            :elevation="isHovering ? 12 : 2"
            :class="{ 'on-hover': isHovering }"
            height="100%"
            class="category-card"
          >
            <v-img
              src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
              height="200"
              cover
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            >
              <v-card-title class="text-white">{{ $t('home.categories.verdicts.title') }}</v-card-title>
            </v-img>
            <v-card-text>
              <p>{{ $t('home.categories.verdicts.description') }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                variant="tonal"
                @click="$router.push('/verdicts')"
                class="mx-auto mb-2"
              >
                {{ $t('home.categories.verdicts.button') }}
                <v-icon end>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            v-bind="props"
            :elevation="isHovering ? 12 : 2"
            :class="{ 'on-hover': isHovering }"
            height="100%"
            class="category-card"
          >
            <v-img
              src="https://images.unsplash.com/photo-1457369804613-52c61a468e7d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
              height="200"
              cover
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            >
              <v-card-title class="text-white">{{ $t('home.categories.stories.title') }}</v-card-title>
            </v-img>
            <v-card-text>
              <p>{{ $t('home.categories.stories.description') }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                variant="tonal"
                @click="$router.push('/stories')"
                class="mx-auto mb-2"
              >
                {{ $t('home.categories.stories.button') }}
                <v-icon end>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Quote Section -->
    <v-sheet color="secondary" class="mt-10 py-10">
      <v-container>
        <blockquote class="blockquote text-center text-white">
          <p class="text-h5 font-italic">
            "{{ $t('home.quote.text') }}"
          </p>
          <footer class="blockquote-footer text-white mt-2">
            <cite>{{ $t('home.quote.author') }}</cite>
          </footer>
        </blockquote>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
/* 基础样式 */
.text-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  position: relative;
  z-index: 2;
}

/* Hero Banner 基础样式 */
.hero-banner {
  position: relative;
  overflow: hidden;
}

.hero-parallax {
  position: relative;
  z-index: 1;
}

/* 胶片效果覆盖层 */
.film-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%),
    linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
  background-size: 100% 2px, 3px 100%;
  pointer-events: none;
  z-index: 3;
}

/* 标题样式 */
.hero-title {
  color: #FFD700 !important; /* 金色 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 20px rgba(255, 215, 0, 0.3) !important;
  letter-spacing: 2px !important;
  font-weight: 800 !important;
  line-height: 1.3;
  position: relative;
}

.hero-subtitle {
  color: #E0E0E0 !important; /* 浅灰白色 */
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8) !important;
  letter-spacing: 1px !important;
}

/* 分类标签样式 */
.classification-tag {
  display: inline-block;
  padding: 4px 12px;
  background-color: rgba(139, 0, 0, 0.8);
  border: 1px solid #FFD700;
  border-radius: 2px;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: #FFD700;
}

/* 卡片样式 */
.category-card {
  transition: transform 0.3s;
  overflow: hidden;
}

.category-card.on-hover {
  transform: translateY(-8px);
}

/* 引用样式 */
.blockquote {
  font-family: 'Playfair Display', Georgia, serif;
  position: relative;
  padding: 0 2rem;
}

.blockquote::before,
.blockquote::after {
  content: '"';
  font-size: 3rem;
  position: absolute;
  opacity: 0.3;
}

.blockquote::before {
  top: -1.5rem;
  left: 0;
}

.blockquote::after {
  bottom: -3rem;
  right: 0;
}

.blockquote-footer {
  font-size: 1rem;
  opacity: 0.8;
}

/* 扫描线效果 */
.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  z-index: 4;
  animation: scanline 6s linear infinite;
  pointer-events: none;
}

@keyframes scanline {
  0% {
    top: -10px;
  }
  100% {
    top: 400px;
  }
}

/* 灰尘和划痕效果 */
.dust-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('data:image/png;base64,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');
  opacity: 0.03;
  z-index: 2;
  pointer-events: none;
  animation: dust 60s linear infinite;
}

@keyframes dust {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}

/* 打字机效果 */
.typewriter {
  overflow: hidden;
  border-right: 3px solid #FFD700;
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 2px;
  animation:
    typing 3.5s steps(30, end),
    blink-caret .75s step-end infinite;
}

@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: #FFD700 }
}

/* 淡入效果 */
.fade-in {
  opacity: 0;
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 3.5s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 闪烁效果 */
.blink {
  animation: blinking 3s infinite;
}

@keyframes blinking {
  0% { opacity: 1; }
  40% { opacity: 1; }
  50% { opacity: 0.5; }
  60% { opacity: 1; }
  100% { opacity: 1; }
}

/* Additional styles are in global styles.css */
</style>
